import { EnvironmentConfiguration } from "./environment-type";

/**
 * This file is used as part of our docker file.
 * The values on the {@link Window} object are the values which we are passing into the docker container via environment variables.
 * => pnpm build
 *
 * Note: This file is intended to be used for ALL our live environments which run the frontend as a container.
 */
export const environment: EnvironmentConfiguration = {
  environment: window.env.ENVIRONMENT,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  backendBaseUrl: window.env.BACKEND_BASE_URL,
};
